import { useFormContext } from 'react-hook-form';
import { KEYWORD_INPUT_ID } from '../../constants';
import { useSearchContext } from '../../context/Search';

const useHorizontalSearchBarLogic = () => {
  const {
    selectedSearchArea: [selectedSearchArea],
  } = useSearchContext();
  const { getValues } = useFormContext();
  const hasKeyword = !!getValues(KEYWORD_INPUT_ID);
  const hasSearchArea = !!selectedSearchArea;

  const submitButtonDisabled = !hasSearchArea || !hasKeyword;

  return { submitButtonDisabled };
};

export default useHorizontalSearchBarLogic;
